import * as React from "react";

const SvgIcnMore = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="currentColor" fillRule="evenodd">
            <circle cx={8} cy={12} r={1} />
            <circle cx={12} cy={12} r={1} />
            <circle cx={16} cy={12} r={1} />
        </g>
    </svg>
);

export default SvgIcnMore;
